import type { AdminOverviewMetrics } from "@care-by-ella/contracts";
import { API_BASE, apiFetch, tenantHeader, withCredentials } from "./api";
import { jsonOr401 } from "./clinician-api";

// TES-580 — the admin overview client (admin-only endpoint, counts only).

export class MetricsApiError extends Error {}

export async function fetchOverviewMetrics(): Promise<AdminOverviewMetrics> {
  const res = await apiFetch(`${API_BASE}/employee-api/v1/metrics/overview`, {
    headers: tenantHeader(),
    ...withCredentials,
  });
  if (res.status === 401 || res.status === 403) {
    return jsonOr401<AdminOverviewMetrics>(res);
  }
  if (!res.ok) throw new MetricsApiError(`HTTP ${res.status}`);
  return (await res.json()) as AdminOverviewMetrics;
}
